import React ,{useState} from 'react'
import axios from "axios";
import { APIURL,TZ } from "../../../Global";
import './profile.css'
import {Button ,Modal } from 'react-bootstrap';
import { useAlert } from 'react-alert';

function CouncilUpdate(props) {
    const alert = useAlert();
    const[council ,setCouncil] =useState(props.council !== " " ? props.council : " ")
    const id = props.id1
    const [error,setError]=useState({
        council:''
       });

    const handleChange=(e)=>{
        e.preventDefault();
        const val=e.target.value;  
        const key=e.target.name;
      
          if(key==='council'){
            setCouncil(val)
          }  
        }

        const  validate = () => {
          //let input = email;
          let errors = {};
          let isValid = true;
    
          if (council==="" ) {
            isValid = false;
            errors["council"] = "Enter Council";
          }
      
          setError(currentstate=>({
            ...currentstate,...errors
          }))
      
          return isValid;
      }

      const handleContinue =async(e) => {
        e.preventDefault();
    
        if( validate() ){
          submitAddress()
        }
      }

        const submitAddress = (e) =>{
            const tokenString= sessionStorage.getItem('usertoken');
             
             let str= tokenString.replace(/["]+/g, '') 
          
             const data = {
                registration_council : council
             }
          
             axios.put(`${APIURL}/api/v1/doctor/medical-profile-update-view/${id}/` ,data, { headers: {
          
              "Authorization" : 'Token '+str  }})
            .then(res=>{
            
                  
              if(res.data.status==="success"){
                
                alert.success("Updated successfully")
                props.handle()
            
              }else{
                alert.error("Error in Data Submission. Please try again!")              
               
              }
            
            })
            .catch(err=>{
              alert.error("Error in Data Submission. Please try again!")
            })
          
          }

    return (
        <div>
            <div className="item"><input className="form-control" value={council} type="text" maxLength="150" name="council" placeholder="Registration Council" onChange={handleChange}/>

                {error.council ? <div className="error-validation-msg"> {error.council}</div> : null}

            </div>
            <br/>
            <div className="form-button">
                <button  onClick={handleContinue} className="btn btn-primary btn-col" >Update Registration Council</button>
            </div>           
        </div>
    )
}

export default CouncilUpdate
